import { ShieldLockOpenIcon } from './ShieldLockOpenIcon';

/**
 * author: Michael Irigoyen
 * id 5B854DDA-2B72-49FC-881D-E88ED51EA636
 * name shield-lock-open
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-lock-open.svg
 * tags
 * - Home Automation 
 * - Lock 
 */
export const ShieldUnlockedIcon = ShieldLockOpenIcon;
export default ShieldUnlockedIcon